import type { Formatter } from '../format'

export class CapitalizedFormatter implements Formatter {
  format(parts: string[]) {
    return parts.reduce<string>((acc, part, index) => {
      if (index === 0) {
        return part.charAt(0).toUpperCase() + part.slice(1)
      }

      return `${acc} ${part}`
    }, '')
  }
}
